var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4698 0.203125H2.49481C1.63376 0.203125 0.9375 0.882904 0.9375 1.72336V19.7725C0.9375 20.613 1.63376 21.2969 2.49481 21.2969H20.4698C21.3309 21.2969 22.0312 20.613 22.0312 19.7766V1.72336C22.0312 0.882904 21.3309 0.203125 20.4698 0.203125ZM7.19559 18.1781H4.06448V8.10916H7.19559V18.1781ZM5.63004 6.73724C4.62479 6.73724 3.81317 5.92563 3.81317 4.9245C3.81317 3.92337 4.62479 3.11176 5.63004 3.11176C6.63116 3.11176 7.44278 3.92337 7.44278 4.9245C7.44278 5.92151 6.63116 6.73724 5.63004 6.73724ZM18.9125 18.1781H15.7855V13.2837C15.7855 12.1178 15.7649 10.614 14.1582 10.614C12.5308 10.614 12.2836 11.8871 12.2836 13.2013V18.1781H9.16077V8.10916H12.16V9.4852H12.2012C12.6173 8.69418 13.6391 7.85785 15.1593 7.85785C18.3275 7.85785 18.9125 9.9425 18.9125 12.6534V18.1781Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.3aeb0c23134a24fd492e6354d73170b1.svg";
export { ForwardRef as ReactComponent };